<template lang="html">
  <div>
    <flv-growth-css 
      v-if="scheme === 'css'" 
      :data="data" 
      :tables="tables" 
      :split-percent="splitPercent" 
      @percent-change="e => $emit('percent-change', e)"
    />
    <flv-growth-dfrdb 
      v-if="scheme === 'dfrdb'" 
      :data="data" 
      :tables="tables" 
      :split-percent="splitPercent" 
      @percent-change="e => $emit('percent-change', e)"
    />
    <flv-growth-msbs 
      v-if="scheme === 'msbs'" 
      :data="data" 
      :tables="tables" 
      :split-percent="splitPercent" 
      @percent-change="e => $emit('percent-change', e)"
    />
    <flv-growth-pss 
      v-if="scheme === 'pss'" 
      :data="data" 
      :tables="tables" 
      :split-percent="splitPercent" 
      @percent-change="e => $emit('percent-change', e)"
    />
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import chartOptions from './chart-options'


export default {
  mixins: [ helpers, chartOptions ],
  props: {
    data: Object,
    tables: Object,
    splitPercent: Number
  },
  data () {
    return {
      nonMemberSeries: [],
      memberChartOneSeries: [],
      memberChartTwoSeries: [],
      xValues: []
    }
  },
  computed: {
    scheme () {
      return this.data.super_type
    },
  }
  
}
</script>

<style lang="css">
</style>
